import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UiDropdownComponent } from '../../ui-kit/ui-dropdown/ui-dropdown.component';
import { PartnerAppSelection } from '../../models/auth.models';

@Component({
  selector: 'app-apps-menu',
  templateUrl: './apps-menu.component.html',
  styleUrl: './apps-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslatePipe],
})
export class AppsMenuComponent {
  @Input({ required: true })
  public appId!: string;

  @Input({ required: true })
  public dropdown!: UiDropdownComponent;

  @Input({ required: true })
  public orgId!: string;

  @Input({ required: true })
  public webUrl!: string;

  @Input({ required: true })
  public controlCenterUrl!: string;

  @Input({ required: true })
  public parkingUrl!: string;

  @Input({ required: true })
  public sitePlannerUrl!: string;

  @Input({ required: true })
  public panicUrl!: string;

  @Input()
  public isWebAllowed = true;

  @Input()
  public isControlCenterAllowed = true;

  @Input()
  public isParkingAllowed = false;

  @Input()
  public isSitePlannerAllowed = true;

  @Input()
  public isPanicAllowed = true;

  @Output()
  public switchApp = new EventEmitter<PartnerAppSelection>();

  public isActive(id: string): boolean {
    return id === this.appId;
  }

  public onSwitchApp(url: string): void {
    this.switchApp.emit({
      url,
    });
    this.dropdown.toggleDropdown();
  }
}
